module.exports = __webpack_public_path__ + "img/11.289450b1.png";